//Events when navigation back
window.addEventListener('popstate', function (e) {
  var page = e.state;
  if (page == null) {
  } else {
     //close active open window
     closeContainer();
  }
});

document.addEventListener('click', (e) => {
  if (e.target.classList.contains('close-page-container')) {
     e.preventDefault();
     closeContainer();    
 }
});


closeContainer = function (sourceElement, targetContainer) {
    sourceElementButton = sourceElement.querySelector('.page-card__more');
    sourceElementButton.innerHTML = 'lees meer +';
    sourceElementButton.classList.remove('open');    
    // Remove the container div
    if (targetContainer && targetContainer.parentElement) {
        targetContainer.remove();
    }
};

updateContainer = function (url, sourceElement, targetContainer, toFectContentClass) {
 
    sourceElementLinks = sourceElement.querySelectorAll('a');
    sourceElementLinks.forEach(link => link.classList.add('disabled'));
    prevUrl = window.location.href;
    sourceElementButton = sourceElement.querySelector('.page-card__more');
 
    //Fetch data
    fetch(url, {
    headers: {
    'X-Requested-With': 'fetch'
    }
    })
    .then(function (response) {
    //Get data as html/text
    return response.text();
    })
    .then(function (html) {
    //Fill the new container with content
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    // Search for divs with specified classes and combine them (including parent elements)
    var classes = Array.isArray(toFectContentClass) ? toFectContentClass : [toFectContentClass];
    var combinedContent = '';
    classes.forEach(function(className) {
      var pageContent = doc.querySelector('.' + className);
      if (pageContent) {
        combinedContent += pageContent.outerHTML;
      }
    });
    targetContainer.innerHTML = combinedContent;
    //Re-Enable link
    sourceElementLinks.forEach(link => link.classList.remove('disabled'));
    history.pushState(url, null, url);
    sourceElementButton.classList.add('open');
        sourceElementButton.innerHTML = 'sluit blok x';
        sourceElementButton.scrollIntoView({ behavior: 'smooth', block: 'center' });

 })
 .catch(function (err) {
   // There was an error
   console.warn('Something went wrong.', err);
 });
}; //updateContainer
